import { Conversation, Message } from '../types';
import { mockTeamMembers } from './mockUsers';

// Mock messages for conversations
export const mockMessages: Message[] = [
  // Conversation with Sofia Chen (EcoTech Solutions)
  {
    id: 'msg-1',
    senderId: 'demo-user',
    receiverId: '1',
    content: 'Hi Sofia! I\'m really impressed with your EcoTech Solutions concept. The 30% energy cost reduction in pilot programs is remarkable.',
    timestamp: new Date('2024-01-15T10:30:00'),
    read: true
  },
  {
    id: 'msg-2',
    senderId: '1',
    receiverId: 'demo-user',
    content: 'Thank you! We\'re excited about the potential impact. I\'d love to discuss how your investment expertise could help us scale.',
    timestamp: new Date('2024-01-15T10:45:00'),
    read: true
  },
  {
    id: 'msg-3',
    senderId: 'demo-user',
    receiverId: '1',
    content: 'I specialize in CleanTech investments and have experience with similar B2B SaaS models. What\'s your current runway and key metrics?',
    timestamp: new Date('2024-01-15T11:00:00'),
    read: true
  },
  {
    id: 'msg-4',
    senderId: '1',
    receiverId: 'demo-user',
    content: 'We have 8 months runway. Key metrics: 15 enterprise clients, $50K MRR, 25% month-over-month growth. Looking to close our seed round by Q2.',
    timestamp: new Date('2024-01-15T11:15:00'),
    read: false
  },

  // Conversation with David Kim (FinFlow)
  {
    id: 'msg-5',
    senderId: '4',
    receiverId: 'demo-user',
    content: 'Hello! Thanks for connecting on RacksMatch. I saw your portfolio includes several FinTech investments. FinFlow is processing $50M+ monthly - would love to share our Series B deck.',
    timestamp: new Date('2024-01-14T14:20:00'),
    read: true
  },
  {
    id: 'msg-6',
    senderId: 'demo-user',
    receiverId: '4',
    content: 'Impressive volume! I\'d definitely like to see the deck. What\'s your target raise amount and timeline?',
    timestamp: new Date('2024-01-14T14:35:00'),
    read: true
  },
  {
    id: 'msg-7',
    senderId: '4',
    receiverId: 'demo-user',
    content: 'We\'re raising $15M Series B, targeting to close by March. Main use cases: team expansion, regulatory compliance, and international expansion.',
    timestamp: new Date('2024-01-14T15:00:00'),
    read: true
  },

  // Conversation with Jennifer Walsh (Investor)
  {
    id: 'msg-8',
    senderId: '5',
    receiverId: 'demo-user',
    content: 'Hi! I noticed you\'re an entrepreneur in the FinTech space. I\'m always looking for innovative B2B solutions. What stage is your company at?',
    timestamp: new Date('2024-01-13T09:15:00'),
    read: true
  },
  {
    id: 'msg-9',
    senderId: 'demo-user',
    receiverId: '5',
    content: 'Thanks for reaching out! We\'re at MVP stage with early customer validation. Building AI-powered financial analytics for SMBs.',
    timestamp: new Date('2024-01-13T09:30:00'),
    read: true
  }
];

// Create a demo user for conversations (will be replaced by actual user)
const demoUser = {
  id: 'demo-user',
  name: 'Demo User',
  age: 30,
  location: 'Madrid, España',
  userType: 'entrepreneur' as const,
  images: ['https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=400&h=600&fit=crop']
};

export const mockConversations: Conversation[] = [
  {
    id: 'conv-1',
    participants: [demoUser, mockTeamMembers.find(u => u.id === '1')!],
    messages: mockMessages.filter(m => 
      (m.senderId === 'demo-user' && m.receiverId === '1') || 
      (m.senderId === '1' && m.receiverId === 'demo-user')
    ),
    lastMessage: mockMessages.find(m => m.id === 'msg-4'),
    updatedAt: new Date('2024-01-15T11:15:00')
  },
  {
    id: 'conv-2',
    participants: [demoUser, mockTeamMembers.find(u => u.id === '4')!],
    messages: mockMessages.filter(m => 
      (m.senderId === 'demo-user' && m.receiverId === '4') || 
      (m.senderId === '4' && m.receiverId === 'demo-user')
    ),
    lastMessage: mockMessages.find(m => m.id === 'msg-7'),
    updatedAt: new Date('2024-01-14T15:00:00')
  },
  {
    id: 'conv-3',
    participants: [demoUser, mockTeamMembers.find(u => u.id === '5')!],
    messages: mockMessages.filter(m => 
      (m.senderId === 'demo-user' && m.receiverId === '5') || 
      (m.senderId === '5' && m.receiverId === 'demo-user')
    ),
    lastMessage: mockMessages.find(m => m.id === 'msg-9'),
    updatedAt: new Date('2024-01-13T09:30:00')
  }
];